import TYPES from '../types';

export default value => {
  return {
    type: TYPES.SET_ACTIVE_VIEW,
    payload: { value },
  };
};
